import { ReactNode } from 'react';

import CheckIcon from '@/icons/CheckIcon.svg?react';
import { cn } from '@/utils/tailwind';

export function DatasetSessionCompareFilterItem(props: {
  label: ReactNode;
  n?: number;
  isNested?: boolean;
  selected: boolean;
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div
      className={cn(
        'relative cursor-default select-none py-1 pl-3 ui-active:bg-secondary-hover',
        props.isNested ? 'pl-10' : 'mt-1'
      )}
      onClick={() => {
        props.onChange(props.value);
      }}
    >
      <span
        className={cn(
          'flex items-center justify-between whitespace-nowrap text-sm font-semibold capitalize',
          props.isNested && 'font-normal'
        )}
      >
        {props.label}

        {props.n != null && (
          <span className="flex min-h-[20px] min-w-[20px] items-center justify-center rounded bg-secondary px-1 py-0.5 text-center text-xs">
            {props.n}
          </span>
        )}
      </span>
      {props.isNested && (
        <span
          className={cn(
            'absolute inset-y-0 left-0 flex items-center pl-3',
            props.isNested && 'pl-3'
          )}
        >
          <div
            className={cn(
              'flex h-4 w-4 items-center justify-center rounded-[4px] border border-secondary text-brand-green-400',
              props.selected && 'border-brand bg-brand-tertiary'
            )}
          >
            {props.selected && (
              <CheckIcon className="h-4 w-4" aria-hidden="true" />
            )}
          </div>
        </span>
      )}
    </div>
  );
}
